import { SkillsParamsType } from "../../@types/globalTypes";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function createSkills(
  params: SkillsParamsType,
  skills: string[]
): Promise<ApiResponse> {
  return Axios.post(
    `/v1/tutors/skills`,
    {
      skills,
    },
    { params }
  );
}

export function indexCandidateSkills(
  params: SkillsParamsType
): Promise<ApiResponse> {
  return Axios.get(`/v1/tutors/skills`, { params });
}
